import { render } from "./PosSalesReportPage.vue?vue&type=template&id=287466dc&scoped=true&ts=true"
import script from "./PosSalesReportPage.vue?vue&type=script&lang=ts"
export * from "./PosSalesReportPage.vue?vue&type=script&lang=ts"

import "./PosSalesReportPage.vue?vue&type=style&index=0&id=287466dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-287466dc"]])

export default __exports__